import { jsx as o } from "react/jsx-runtime";
import i from "styled-components";
import r from "../../../utils/colors.js";
const e = i.div`
  position: relative;
`, t = i.a`
  position: relative;
  background: transparent;
  border: none;
  outline-color: ${r.orange};
  padding: 0;
  padding-top: 2px;
  padding-bottom: 0px;
  padding-left: 7px;
  padding-right: 7px;
  color: ${r.blueGrey};
  font-weight: normal;
  transition: color 0.15s ease-in-out;

  &:hover,
  &:focus {
    color: ${r.brown};
  }
`, u = ({ text: n, link: d, isLastItem: a, enableLink: l }) => !a || l ? /* @__PURE__ */ o(
  t,
  {
    href: d,
    "aria-hidden": "false",
    style: { textDecoration: "underline", cursor: "pointer" },
    children: /* @__PURE__ */ o(e, { children: n })
  }
) : /* @__PURE__ */ o(t, { children: /* @__PURE__ */ o(e, { children: n }) });
export {
  u as default
};
